var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{staticClass:"hp-bg-color-dark-90 min-vh-100 d-flex"},[_c('sidebar'),_c('div',{staticClass:"hp-main-layout"},[_c('app-header'),_c('div',{staticClass:"hp-main-layout-content w-100 mw-100 px-5"},[_c('vue-page-transition',{attrs:{"name":"fade-in-up"}},[_c('router-view')],1)],1),_c('app-footer')],1)],1),_c('scroll-to-top')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }